export default __webpack_public_path__ + "static/Plots0002-04b38e1942e559102ca701c8c1a528fd.jpg";